<template>
  <b-container>
    <b-row>
      <b-col cols="8">
        <b-row>
          <b-col>
            <b-form-group
              :id="`asset-url-group-${refId}`"
              :label="label"
              :label-for="`asset-url-input-${refId}`">
              <b-input-group>
                <b-form-input
                  :id="`asset-url-input-${refId}`"
                  :ref="`input-${refId}`"
                  v-model="imageURL"
                  :disabled="!canEdit"
                  :state="isCloudinaryUrl(imageURL)"
                  type="url"
                  required
                  trim />
                <b-input-group-append>
                  <b-btn
                    variant="outline-primary"
                    @click.prevent="$refs[refId].show()">
                    <i class="fas fa-plus" />
                  </b-btn>
                </b-input-group-append>
                <b-form-invalid-feedback>
                  Enter a valid Cloudinary URL
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="hasAdditionalLabelSlot">
          <b-col>
            <slot name="additional-label" />
          </b-col>
        </b-row>
      </b-col>
      <b-col align-self="center">
        <b-img
          v-if="isCloudinaryUrl(imageURL)"
          width="128"
          :src="imageURL"
          fluid />
      </b-col>
    </b-row>
    <b-modal
      :ref="refId"
      hide-header
      hide-footer
      size="lg">
      <asset-upload
        :post-action="`https://api.cloudinary.com/v1_1/${CLOUDINARY_ACCOUNT}/image/upload`"
        :allow-multiple-uploads="false"
        :without-auth-header="true"
        :accept="accept"
        :extensions="extensions"
        :cloudinary="{}"
        @asset-selected-response="onAssetSelect"
        @cancel="$refs[refId].hide()" />
    </b-modal>
  </b-container>
</template>

<script>
  import AssetUpload from "../AssetUpload"

  export default {
    name: "LogoUpload",
    components: {
      AssetUpload,
    },
    props: {
      value: {
        type: String,
        required: false,
        default: null,
      },
      canEdit: {
        type: Boolean,
        required: true,
      },
      refId: {
        type: String,
        required: true,
      },
      label: {
        type: String,
        required: true,
      },
      accept: {
        type: String,
        default: "image/svg+xml",
      },
      extensions: {
        type: String,
        default: "svg",
      },
    },
    data() {
      return {
        assetPreviewLoadedRatio: 0,
      }
    },
    computed: {
      imageURL: {
        get: function() {
          return this.value
        },
        set: function (value) {
          this.$emit("input", value)
        },
      },
      CLOUDINARY_ACCOUNT() {
        return process.env.VUE_APP_CLOUDINARY_ACCOUNT
      },
      hasAdditionalLabelSlot() {
        return !!this.$slots["additional-label"]
      },
    },
    methods: {
      isCloudinaryUrl(url) {
        const valid = /^(http|https):\/\/[^ "]+$/i.test(url) &&
          (url.includes("res.cloudinary") || url.includes("img.mlbstatic"))
        if (!valid) {
          this.$emit("on-error", valid)
        }
        return valid
      },
      onAssetSelect(response) {
        this.$refs[this.refId].hide()
        console.log(`New asset url: ${response.url}, publicId: ${response.public_id}`)

        if (response) {
          this.$emit("input", `https://img.mlbstatic.com/mlb-mobile/${response.public_id}`)
        } else {
          console.warn('Ignoring invalid asset selection')
        }
      },
    },
  }
</script>

<style scoped>

</style>
